/*
  Charmlry A/B Customizer.
  Assigns the shopper to one arm (live | classic | chat | classicnew), routes the CUSTOMIZE
  button, and publishes the funnel events for every arm through
  Shopify.analytics.publish (consumed by the Custom Pixel).

  Events (customData always carries ab_customizer):
    ab_view          product page seen
    ab_open          CUSTOMIZE tapped
    ab_step          a step reached inside the classic/chat customizers (cfg_step)
    ab_add_to_cart   a line added to the cart (value, currency, quantity)
  The arm is also stored as the cart attribute "ab_customizer" and in the
  cookie "charmlry_ab" so the purchase can be attributed at checkout.
  classicnew = the classic with the new flow (Stones + Gift steps, short
  review): <html data-cfg-new="1">, read by configurator-v2.js at open().
  Test round (setting): a shopper stored in another round, or in an arm
  that now has weight 0, is drawn again (ab_source "reassigned").
*/
(function () {
  'use strict';
  if (window.CharmlryAB) return;
  var root = document.querySelector('[data-ab-customizer]');
  if (!root) return;

  var ARMS = ['live', 'classic', 'chat', 'classicnew'];
  var KEY = 'charmlry_ab', ROUND_KEY = 'charmlry_ab_round';
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-ab-config]').textContent); } catch (err) { cfg = {}; }
  var days = Math.max(1, +cfg.cookieDays || 90);
  var weights = cfg.weights || {};
  var round = String(cfg.round || '');

  /* ---------- assignment ---------- */
  function readCookie() { var m = document.cookie.match(new RegExp('(?:^|; )' + KEY + '=([a-z]+)')); return m ? m[1] : null; }
  function writeCookie(v) {
    try { document.cookie = KEY + '=' + v + '; Max-Age=' + days * 86400 + '; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch (err) { /* ignore */ }
  }
  function stored() {
    var v = null;
    try { v = localStorage.getItem(KEY); } catch (err) { /* ignore */ }
    if (ARMS.indexOf(v) === -1) v = readCookie();
    return ARMS.indexOf(v) > -1 ? v : null;
  }
  function store(v) {
    try { localStorage.setItem(KEY, v); } catch (err) { /* ignore */ }
    writeCookie(v);
    if (round) {
      try { localStorage.setItem(ROUND_KEY, round); } catch (err) { /* ignore */ }
      try { document.cookie = ROUND_KEY + '=' + encodeURIComponent(round) + '; Max-Age=' + days * 86400 + '; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch (err) { /* ignore */ }
    }
  }
  function storedRound() {
    var v = '';
    try { v = localStorage.getItem(ROUND_KEY) || ''; } catch (err) { /* ignore */ }
    if (!v) { var m = document.cookie.match(new RegExp('(?:^|; )' + ROUND_KEY + '=([^;]*)')); if (m) { try { v = decodeURIComponent(m[1]); } catch (err) { v = m[1]; } } }
    return v;
  }
  function draw(arms) {
    arms = arms || ARMS;
    var total = 0;
    arms.forEach(function (a) { total += Math.max(0, +weights[a] || 0); });
    if (!total) return arms.length < ARMS.length ? arms[Math.floor(Math.random() * arms.length)] : (cfg.defaultArm || 'live');
    var r = Math.random() * total;
    for (var i = 0; i < arms.length; i++) { r -= Math.max(0, +weights[arms[i]] || 0); if (r < 0) return arms[i]; }
    return arms[arms.length - 1];
  }
  // The live personalizer exists only on the old product page (its CUSTOMIZE
  // button). On the new page a stored "live" shopper is drawn again between
  // classic and chat, once, and tracked with ab_source "reassigned".
  var hasLive = !!document.querySelector('.js-button-customize');
  var override = null;
  try { var q = new URLSearchParams(location.search).get('customizer'); if (ARMS.indexOf(q) > -1) override = q; } catch (err) { /* ignore */ }

  // Arms that can be drawn now: a weight above 0, and the live one only where
  // the live personalizer exists.
  var pool = ARMS.filter(function (a) { return Math.max(0, +weights[a] || 0) > 0 && (a !== 'live' || hasLive); });
  var arm, source;
  if (override) { arm = override; source = 'override'; store(arm); }
  else if (!cfg.enabled) { arm = cfg.defaultArm || 'live'; source = 'off'; }
  else {
    arm = stored(); source = arm ? 'stored' : 'new';
    if (!arm) { arm = draw(pool.length ? pool : (hasLive ? ARMS : ['classic', 'chat'])); store(arm); }
    else if (pool.length && ((round && storedRound() !== round) || pool.indexOf(arm) === -1)) { arm = draw(pool); source = 'reassigned'; store(arm); }
  }

  function elFor(a) {
    if (a === 'live') return null;
    return document.querySelector(a === 'chat' ? 'configurator-chat-element' : 'configurator-modal-element');
  }
  // The chosen experience must exist on the page, otherwise fall back to live.
  if (arm !== 'live' && !elFor(arm)) { arm = 'live'; source = 'fallback'; }

  root.dataset.pdpCustomizer = arm; // read by configurator-v2.js (chatWanted)
  document.documentElement.setAttribute('data-ab-customizer', arm);
  document.documentElement.setAttribute('data-cfg-new', arm === 'classicnew' ? '1' : '0'); // read by configurator-v2.js (cfgNewFlow)

  /* ---------- tracking ---------- */
  // QA visits (?customizer=... override), theme editor and bots are never tracked.
  var noTrack = !cfg.enabled || source === 'override' || !!(window.Shopify && window.Shopify.designMode) || !!navigator.webdriver;
  var queue = [];
  function flush() {
    if (!(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function')) return false;
    while (queue.length) { var ev = queue.shift(); try { Shopify.analytics.publish(ev[0], ev[1]); } catch (err) { /* ignore */ } }
    return true;
  }
  var tries = 0;
  var timer = setInterval(function () { if (flush() || ++tries > 40) clearInterval(timer); }, 250);
  function publish(name, data) {
    var payload = Object.assign({ ab_customizer: arm, ab_source: source, product: cfg.product || '', page: location.pathname }, data || {});
    try { document.dispatchEvent(new CustomEvent('charmlry:ab', { detail: { name: name, data: payload } })); } catch (err) { /* ignore */ }
    if (noTrack) return;
    queue.push([name, payload]);
    flush();
  }

  /* ---------- CUSTOMIZE button ---------- */
  var trigger = cfg.trigger || 'form[action*="/cart/add"] .product-form__submit, [data-ab-open]';
  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest(trigger) : null;
    if (!btn) return;
    publish('ab_open', {});
    if (arm === 'live') return; // the theme's own handler opens the personalizer
    var el = elFor(arm);
    if (!el || typeof el.open !== 'function') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    el.open(e);
  }, true);

  /* ---------- steps (classic + chat emit cfg:step) ---------- */
  var lastStep = null;
  document.addEventListener('cfg:step', function (e) {
    var d = e.detail || {};
    if (!d.step || d.step === lastStep) return;
    lastStep = d.step;
    publish('ab_step', { cfg_step: d.step, engine: d.engine || '' });
  });

  /* ---------- add to cart: watch /cart/add for every arm ---------- */
  var nativeFetch = window.fetch;
  var tagged = false;
  function tagCart() {
    if (tagged || (noTrack && source !== 'override')) return; // override: tagged as such so the order can be excluded
    tagged = true;
    setTimeout(function () {
      try {
        nativeFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { ab_customizer: arm, ab_source: source } }) }).catch(function () { tagged = false; });
      } catch (err) { tagged = false; }
    }, 1500);
  }
  /* Add-ons, so the three arms can be compared on what they sell on top of the
     design, not only on the total. Birthstones ride as satellites of the piece
     (property _parent); the scratch card, the gift box and the warranty are
     their own lines (the warranty is offered by the live personalizer only). */
  function addonOf(it) {
    var title = String(it.product_title || it.title || '');
    if (/warranty/i.test(title)) return 'warranty';
    if (/scratch/i.test(title)) return 'scratch';
    if (/gift box/i.test(title)) return 'gift';
    if (it.properties && it.properties._parent) return 'stones';
    return null;
  }
  function onAdded(json) {
    var items = json && json.items ? json.items : (json && json.id ? [json] : []);
    if (!items.length) return;
    var value = 0, qty = 0, titles = [];
    var stones = 0, addonsValue = 0, designValue = 0;
    var has = { scratch: false, gift: false, warranty: false };
    items.forEach(function (it) {
      var props = it.properties || {};
      var line = (it.final_line_price != null ? it.final_line_price : (it.price || 0) * (it.quantity || 1)) / 100;
      var kind = addonOf(it);
      if (kind === 'stones') { stones += it.quantity || 1; addonsValue += line; }
      else if (kind) { has[kind] = true; addonsValue += line; }
      else designValue += line;
      if (props._parent) return; // satellites stay out of value/quantity, as before
      value += line;
      qty += it.quantity || 1;
      titles.push(it.product_title || it.title || '');
    });
    var addons = [];
    if (stones) addons.push('stones:' + stones);
    ['scratch', 'gift', 'warranty'].forEach(function (k) { if (has[k]) addons.push(k); });
    publish('ab_add_to_cart', {
      value: Math.round(value * 100) / 100,
      currency: cfg.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      quantity: qty,
      items: titles.join(' | '),
      addons: addons.length ? addons.join('|') : 'none',
      addon_stones: stones,
      addon_scratch: has.scratch ? 'yes' : 'no',
      addon_gift: has.gift ? 'yes' : 'no',
      addon_warranty: has.warranty ? 'yes' : 'no',
      addons_value: Math.round(addonsValue * 100) / 100,
      design_value: Math.round(designValue * 100) / 100
    });
    tagCart();
  }
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) { if (res && res.ok) res.clone().json().then(onAdded).catch(function () { /* ignore */ }); }).catch(function () { /* ignore */ });
    }
    return p;
  };

  window.CharmlryAB = { arm: arm, source: source, publish: publish, config: cfg };
  publish('ab_view', {});
})();
